import React, { useState, useEffect } from 'react';

const CommunitiesSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Auto-rotate carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  
  const testimonials = [
    {
      name: 'Theeranop Siriwanich',
      initial: 'T',
      title: 'I don\'t feel confused',
      text: 'When trying to use the platform I have a question about some features that I don\'t understand related to indicators. So I asked the support team and received good help.'
    },
    {
      name: 'Dian Permadi',
      initial: 'D',
      title: 'Good trading platform and experience',
      text: 'PreciseFx offers a really good trading platform. There could be more asset choices than there are now, but SC is still not a bad choice for daily trading.'
    },
    {
      name: 'Jacobo Ortiz',
      initial: 'J',
      title: 'My stats',
      text: 'I like to count and often make statistics of my trades. After I started trading FTT on this platform, my profitability increased by about 15%. This is a good result.'
    },
    {
      name: 'Daniel Clark',
      initial: 'D',
      title: 'Educational platform',
      text: 'The educational materials in the platform can turn any newbie into a pro. They are really useful and right there. No need to surf the whole internet for proper education.'
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-black"></div>
      
      <div className={`relative z-10 max-w-7xl mx-auto px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Global Reach Section */}
        <div className="relative mb-20 animate-fade-in-up">
          <div className="relative h-[400px] md:h-[500px] rounded-3xl overflow-hidden">
            {/* World Background Image */}
            <img 
              src="/images/world.webp" 
              alt="Global reach" 
              className="absolute inset-0 w-full h-full object-cover"
            />
            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
            
            {/* Content */}
            <div className="relative h-full flex flex-col items-center justify-center px-6 space-y-8">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center leading-tight animate-scale-in">
                PreciseFx operates
                <br />
                in 130+ countries
              </h2>
              
              {/* Profile Images Row */}
              <div className="flex items-center justify-center animate-fade-in-up animate-delay-200">
                <img 
                  src="/images/ppl.webp" 
                  alt="Global community" 
                  className="h-16 sm:h-20 md:h-24 w-auto"
                />
                {/* Plus Button - Perfectly Circular */}
                <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 ml-1 sm:ml-2 hover:scale-110 hover:bg-yellow-600 transition-all duration-300 cursor-pointer shadow-lg shadow-yellow-500/50">
                  <span className="text-3xl sm:text-4xl md:text-5xl text-black font-light leading-none">+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Title */}
        <div className="text-center space-y-8 mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold animate-scale-in">
            Trusted by traders worldwide
          </h2>
          <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto animate-fade-in-up animate-delay-200">
            Secure, transparent, and automated.
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative max-w-5xl mx-auto animate-fade-in-up animate-delay-400">
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 md:p-12 min-h-80 border border-gray-800 hover-lift hover-glow">
            <div className="flex items-start space-x-6 animate-fade-in">
              {/* Avatar */}
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 animate-scale-in animate-glow">
                <span className="text-2xl font-bold text-black">{testimonials[currentSlide].initial}</span>
              </div>
              
              {/* Content */}
              <div className="flex-1 space-y-4">
                <div>
                  <h4 className="text-2xl font-bold mb-2 animate-fade-in-up">{testimonials[currentSlide].title}</h4>
                  <p className="text-gray-400 text-lg leading-relaxed animate-fade-in-up animate-delay-100">
                    {testimonials[currentSlide].text}
                  </p>
                </div>
                <div className="text-gray-500 animate-fade-in-up animate-delay-200">{testimonials[currentSlide].name}</div>
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-2 md:-left-16 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-gray-800 hover:bg-gray-700 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 z-10 shadow-lg"
          >
            <span className="text-2xl text-white">←</span>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-2 md:-right-16 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-gray-800 hover:bg-gray-700 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 z-10 shadow-lg"
          >
            <span className="text-2xl text-white">→</span>
          </button>

          {/* Dots */}
          <div className="flex items-center justify-center space-x-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentSlide ? 'bg-yellow-500 w-8' : 'bg-gray-600'
                }`}
              ></button>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default CommunitiesSection;
